import { render, staticRenderFns } from "./IconEgalLight.vue?vue&type=template&id=85451c98&"
import script from "./IconEgalLight.vue?vue&type=script&lang=js&"
export * from "./IconEgalLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports